// @flow strict

import * as React from 'react'

import AccessibilityText from '../AccessibilityText'
import styles from './CountrySwitcher.module.scss'

export type Country = {|
  value: string,
  key: string,
  selected?: boolean,
|}

export type Props = {|
  label: string,
  countries: Array<Country>,
  onChange: (SyntheticInputEvent<HTMLSelectElement>) => void,
|}

const CountrySwitcher = ({ label, countries, onChange }: Props) => {
  const defaultValue = countries.filter(({ selected }) => selected === true)
  return (
    <label>
      <AccessibilityText>{label}</AccessibilityText>
      <select
        className={styles.switcher}
        onChange={onChange}
        defaultValue={defaultValue.length && defaultValue[0].value}
      >
        {countries.map(({ value, key, selected }: Country) => (
          <option value={value} key={key}>
            {key}
          </option>
        ))}
      </select>
    </label>
  )
}

export default CountrySwitcher
